import { Avatar, Box, Typography } from '@material-ui/core'
import ExpandableCard from '../../components/expandable-card'
import { stringAvatar } from '../../utils/functions'

export const ProcessDoneBy = ({ managed_by, ...props }) => {

    return (
        <ExpandableCard realce={true} title={`Gestores`} mini={managed_by?.length < 1}>
            <Box>
                {managed_by?.map((user_context) => (
                    <Box style={{ display: 'flex', padding: '16px', marginBottom: '16px', alignItems: 'center' }}>
                        <Avatar variant={'circle'} {...stringAvatar(user_context?.user?.name || "")} />
                        <Box style={{ marginInline: '16px' }}>
                            <Typography variant="h6">{user_context?.user?.name}</Typography>
                            <Box>
                                <Typography variant="body2" color="textSecondary">
                                    {user_context?.profile?.name}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {user_context?.user?.email}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {user_context?.user?.phone}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        </ExpandableCard>
    )
}
